import { IFetchPtData } from "@types"
import { protectedApi } from "store/Api"

const actionsFetchPtData = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        actionsFetchPtData: builder.query<IFetchPtData[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `actions/fetch_pt_data`,
                }
            },
        }),
    }),
})

export const { useActionsFetchPtDataQuery } = actionsFetchPtData
